import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';

export default function CityDashboard() {
  const { idToken } = useAuth();
  const [zip, setZip] = useState('');
  const [miles, setMiles] = useState(50);
  const [sample, setSample] = useState('4.2599');
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api('/api/me', { token: idToken! }).then(m => { setZip(m.zip); load(m.zip, 50, '4.2599'); });
  }, []);

  async function load(z: string, mi: number, sp: string) {
    setLoading(true);
    try {
      const r = await api(`/api/dashboards/cities?zip=${z}&miles=${mi}&samplePrice=${sp}`, { token: idToken! });
      setData(r);
    } finally { setLoading(false); }
  }

  return (
    <div className="container">
      <div className="card" style={{ marginBottom: 14 }}>
        <h3>Fuel-tax cost by city within {miles} miles</h3>
        <div className="row" style={{ flexWrap: 'wrap' }}>
          <div><label>Center zip</label><input value={zip} onChange={e => setZip(e.target.value)} maxLength={5} /></div>
          <div><label>Radius (mi)</label><input type="number" value={miles} onChange={e => setMiles(parseInt(e.target.value, 10))} /></div>
          <div><label>Sample retail $/gal</label><input value={sample} onChange={e => setSample(e.target.value)} /></div>
          <button onClick={() => load(zip, miles, sample)}>Run</button>
          {loading && <span className="muted small">Loading…</span>}
        </div>
        <p className="muted small">
          Each row applies that city's federal + state + county/district tax stack to the same sample retail
          price so you can compare like-for-like. Lower total tax = greener row.
        </p>
      </div>

      {data && (
        <div className="card">
          <table>
            <thead>
              <tr><th>City</th><th>County</th><th>State</th><th>Distance</th><th style={{ textAlign: 'right' }}>Total tax $/gal</th><th style={{ textAlign: 'right' }}>Pre-tax</th></tr>
            </thead>
            <tbody>
              {data.rows.map((r: any, i: number) => {
                const pretax = (parseFloat(sample) - r.totalTax);
                return (
                  <tr key={i}>
                    <td>{r.city}</td><td className="muted">{r.county}</td><td>{r.state}</td>
                    <td>{r.distanceMiles} mi</td>
                    <td style={{ textAlign: 'right', color: heatColor(r.totalTax, data.rows) }}>${r.totalTax.toFixed(4)}</td>
                    <td style={{ textAlign: 'right' }}>${pretax.toFixed(4)}</td>
                  </tr>
                );
              })}
              {data.rows.length === 0 && <tr><td colSpan={6} className="muted">No tax rules loaded for nearby cities yet — the seed only includes a few states/counties. Add more in Admin → Tax Rules.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function heatColor(v: number, rows: any[]) {
  const vals = rows.map(r => r.totalTax);
  const min = Math.min(...vals), max = Math.max(...vals);
  if (max === min) return undefined;
  const f = (v - min) / (max - min);
  // green → amber → red
  const r = Math.round(52 + (248 - 52) * f);
  const g = Math.round(211 - (211 - 113) * f);
  const b = Math.round(153 - (153 - 113) * f);
  return `rgb(${r},${g},${b})`;
}
